<template>
  <div class="outer">
    <!-- 借款提示 -->
    <el-alert
      class="alert"
      title="借款状态描述"
      type="warning"
      description="
      1、已发起,申请审批中: 借款人提交完借款信息
      2、审批完成: 待付款状态,所有审批人完成审批
      3、申请失败: 审批驳回
      4、申请撤回: 借款人提交完借款信息,在第一个审批人审批前可修改记录、可撤销记录
      5、已付款状态: 借款人完成付款
      6、已还款状态: 借款人完成还款
      7、已发起,无需审批"
    >
    </el-alert>
    <!-- 申请借款 -->
    <el-dialog
      title="申请借款"
      :visible.sync="loanApplyVisible"
      width="40%"
      @close="closeApplyDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="50px"
    >
      <el-card class="box-card">
        <div>
          <el-form
            ref="inputForm"
            label-width="100px"
            :model="loanForm"
            :rules="formRules"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="借款类型"
                  prop="loanType"
                  required
                  style="margin-left: 26px"
                >
                  <el-select
                    v-model="loanForm.loanType"
                    placeholder="请选择借款类型"
                    clearable
                  >
                    <el-option
                      v-for="(item, i) in loanTypeList"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="借款金额" required prop="amount">
                  <el-input
                    type="number"
                    prefix-icon="el-icon-edit"
                    style="width: 200px"
                    v-model.number="loanForm.amount"
                    placeholder="请输入借款金额"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="商机号"
                  prop="chanceId"
                  style="margin-left: 26px"
                >
                  <el-select
                    v-model="loanForm.chanceId"
                    filterable
                    clearable
                    placeholder="请选择商机号"
                  >
                    <el-option
                      v-for="item in chanceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="借款理由"
                  prop="reason"
                  required
                  style="margin-left: 26px"
                >
                  <el-input
                    type="textarea"
                    prefix-icon="el-icon-edit"
                    style="width: 100%"
                    v-model="loanForm.reason"
                    placeholder="请输入借款理由"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="loanApplyVisible = false">取 消</el-button>
        <!-- <el-button @click="">取 消</el-button> -->
        <el-button type="primary" @click="applySubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 借款详情 -->
    <el-dialog
      title="借款详情"
      :visible.sync="loanDetailVisible"
      width="50%"
      top="0px"
      class="loanDetailVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDetailDialog"
    >
      <el-card class="box-card" style="margin-bottom: 20px">
        <div slot="header" class="clearfix">
          <span>借款进度</span>
        </div>
        <el-steps class="steps" :active="stepActive" align-center>
          <el-step :title="stepOneText" :status="stepOneStatus">
            <el-button
              type="danger"
              round
              v-if="
                loanApplyDetail.state == 1 ||
                loanApplyDetail.state == 2 ||
                loanApplyDetail.state == 9
              "
              slot="description"
              class="quash"
              @click="quash"
              >撤销</el-button
            >
          </el-step>
          <el-step
            :title="stepTwoText"
            :icon="stepTwoIcon"
            :status="stepTwoStatus"
          >
          </el-step>
          <el-step :title="stepThreeText" :status="stepThreeStatus">
            <div slot="description" v-if="loanApplyDetail.payUserName">
              <div>付款经手人: {{ loanApplyDetail.payUserName }}</div>
              <div>付款时间: {{ loanApplyDetail.payTime }}</div>
            </div>
          </el-step>
          <el-step :title="stepFourText" :status="stepFourStatus">
            <div slot="description" v-if="loanApplyDetail.backUserName">
              <div>收款经手人: {{ loanApplyDetail.backUserName }}</div>
              <div>收款时间: {{ loanApplyDetail.backTime }}</div>
            </div>
          </el-step>
        </el-steps>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>审批过程</span>
        </div>
        <el-timeline style="margin-top: 30px">
          <el-timeline-item
            :timestamp="item.endTime"
            v-for="(item, i) in approvalStageList"
            :key="i"
          >
            <template v-if="item.approvalResult">
              【已审批-{{ item.approvalResultName }}】, 【操作人：{{
                item.dealUserName
              }}】, 【意见/建议：{{ item.opinion }}】
            </template>
            <template v-else>
              【未审批】 【操作人：{{ item.dealUserName }}】
            </template>
          </el-timeline-item>
        </el-timeline>
      </el-card>
    </el-dialog>
    <!-- 查询条件 -->
    <div class="queryRow">
      <!-- 搜索框查询借款人姓名的,仅财务可见 -->

      <el-date-picker
        class="dataPicker"
        v-model="queryForm.rqScope"
        type="daterange"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        @change="onDateChange"
      >
      </el-date-picker>
      <template v-if="isFinance">
        <el-select
          class="dataPicker"
          v-model="queryForm.state"
          placeholder="请选择借款状态"
          @change="onSelectChange"
        >
          <el-option
            v-for="item in loanRuleStates"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-input
          class="queryName"
          prefix-icon="el-icon-search"
          v-model="queryForm.loanManName"
          size="small"
          placeholder="请输入借款人姓名"
          clearable
        />

        <el-button type="primary" icon="el-icon-search" @click="search">
          搜索
        </el-button>
      </template>

      <el-button
        type="primary"
        style="float: right"
        @click="loanApplyVisible = true"
      >
        申请借款
      </el-button>
    </div>
    <!-- 表格 -->
    <div class="loanList">
      <!-- :key 绑定表头「借款类型」下拉的筛选值：Element 的表头插槽在父组件数据变化时不会重新求值，
           从别处（重置/程序赋值）改到同一个 queryForm.loanType 时表头 el-select 不回显，改 key 强制整表重建。 -->
      <el-table
        class="table"
        :data="tableData"
        v-loading="loading"
        :key="'loanTable-' + queryForm.loanType"
        stripe
        style="margin-bottom: 20px; height: 58vh; overflow: auto"
        border
      >
        <el-table-column
          align="center"
          prop="applyCode"
          label="申请单编号"
          width="180"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="chanceId"
          label="商机号"
          width="80"
        >
        </el-table-column>

        <el-table-column align="center" prop="chanceName" label="商机名称">
        </el-table-column>

        <el-table-column
          align="center"
          prop="loanManName"
          label="借款人"
          width="110"
        >
        </el-table-column>

        <!-- 借款类型：筛选移到表头（下拉）。借款类型是审批链的路由依据，这里只读、不改 -->
        <el-table-column align="center" width="140">
          <template slot="header">
            <el-select
              v-model="queryForm.loanType"
              size="mini"
              placeholder="借款类型"
              style="width: 100%"
              clearable
              @change="onSelectChange"
            >
              <el-option
                v-for="item in loanTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.loanTypeName }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="amount"
          label="借款金额"
          width="110"
        >
          <template slot-scope="scope">
            <span>￥{{ (scope.row.amount).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="overReturn"
          label="已还款金额"
          width="110"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.state === 5 ||
                scope.row.state === 6 ||
                scope.row.state === 7
              "
              >￥{{
                (scope.row.amount - scope.row.waitReturn).toFixed(2)
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="waitReturn"
          label="待还款金额"
          width="110"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.state === 5 || scope.row.state === 6 || scope.row.state === 7">￥{{ (scope.row.waitReturn).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="reason" label="借款理由">
        </el-table-column>

        <!-- 日期与时间分两行显示（formatter + cell-two-line，见 utils/validate.js 与 styles/index.scss）。
             原来这列被挤到 80px，Element 的 word-break: break-all 会从日期中间硬断成 3 行。 -->
        <el-table-column
          align="center"
          prop="loanApplyTime"
          label="借款申请时间"
          width="130"
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
        >
        </el-table-column>


        <el-table-column
          align="center"
          width="180"
          prop="stateName"
          label="借款状态"
        >
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.state)">{{
              scope.row.stateName
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="departmentName"
          label="借款人所属部门"
          width="120"
        >
        </el-table-column>

        <el-table-column align="center" prop="" label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              v-if="!isFinance"
              @click="lookDetail(scope.row)"
              >查看详情</el-button
            >
            <template v-else>
              <el-button
                v-if="financeOperate(scope.row.state) === 'pay'"
                type="primary"
                size="small"
                @click="payReturn(scope.row.id, 1)"
                >付款确认</el-button
              >
              <el-button
                v-else-if="financeOperate(scope.row.state) === 'back'"
                type="primary"
                size="small"
                @click="openRepayment(scope.row, 2)"
                >还款确认</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="display: flex; justify-content: space-between; margin-top: 5px"
      >
        <div style="display: flex; justify-content: space-between">
          <div class="mr-30">已借款总额: ￥{{ loanTotal }}</div>
          <div class="mr-30">已还款总额: ￥{{ overPayTotal }}</div>
          <div class="mr-30">待还款总额: ￥{{ waitPayTotal }}</div>
        </div>
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :page-size="queryForm.limit"
          :current-page="queryForm.page"
          @current-change="onCurrentChange"
          @size-change="onSizeChange"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="还款操作"
        :visible.sync="repaymentDialogVisible"
        width="20%"
        @close="repaymentDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="repaymentForm" ref="repaymentForm">
          <el-form-item
            :label="'还款金额(待还款金额：￥' + (repaymentForm.waitReturn || 0) + ')'"
            prop="returnAmount"
            :rules="[
              { required: true, message: '请输入还款金额', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model.number="repaymentForm.returnAmount"
              placeholder="请输入本次还款金额"
              type="number"
              @input="handleInput"
            />
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="repaymentDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmRepayment" :disabled="paymentDisabled"
            >确认还款</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  loanSubmit,
  getLoanApplyList,
  getApprovalStageList,
  loanCancel,
  payReturnSubmit,
} from "@/api/finance/loan.js";
import { getProjects } from "@/api/work/WorkOrderList.js";
export default {
  data() {
    return {
      paymentDisabled: false, // 付款确认按钮是否禁用
      loanTotal: 0,
      overPayTotal: 0,
      waitPayTotal: 0,
      repaymentDialogVisible: false,
      repaymentStatus: "部分还款", // 假设这是你的还款状态
      repaymentForm: {
        id: null,
        returnAmount: "",
      },
      func: "", // 1: 已审批；2: 待审批；
      loading: false, // 表格加载
      total: 0, // 数据总条数
      loanApplyVisible: false, // 申请借款弹窗
      loanDetailVisible: false, // 借款详情弹窗
      queryForm: {
        page: 1,
        limit: 10,
        loanManName: "",
        rqScope: "",
        state: "",
        loanType: "", // 借款类型筛选（表头下拉）
      }, // 查询表单
      loanRuleStates: [
        {
          value: 99,
          label: "全部",
        },
        {
          value: 29,
          label: "所有待付款记录",
        },
        {
          value: 5,
          label: "已付款待还款", // 已提交申请状态:  借款人填写完提交，在第一审批人审批前可修改记录、可撤销记录
        },
        {
          value: 6,
          label: "已还款", // 部分批人完成审批
        },
        {
          value: 7,
          label: "部分还款", //部分还款
        },
        {
          value: 57,
          label: "未还清款（含已付款待还款、部分还款）", // 已付款未还款(5) + 部分还款(7)
        },
      ], // 借款状态对应表
      tableData: [], //表格数据
      loanForm: {
        loanType: "", // 借款类型
        amount: "", // 借款金额
        reason: "", // 借款理由
        chanceId: "", // 商机号
      }, // 申请借款表单
      formRules: {
        loanType: [{ required: true, message: "请选择借款类型" }],
        amount: [{ required: true, message: "请输入借款金额" }],
        reason: [{ required: true, message: "请输入借款原因" }],
      }, // 申请借款表单验证
      loanTypeList: [
        { value: 1, label: "差旅借款" },
        { value: 2, label: "投标借款" },
        { value: 3, label: "零星采购" },
        { value: 9, label: "其它借款" },
      ],
      isFinance: "", // 判断角色身份是否为财务
      loanApplyDetail: {}, // 借款详情
      approvalStageList: [], // 审批阶段列表
      chanceList: [], // 商机列表
    };
  },
  created() {
    console.log(15.2 + 13.24);
    this.isFinance = sessionStorage.getItem("userRoleId") == 27; // 判断角色身份是否为财务还是申请人
    this.queryForm.state = this.isFinance ? 99 : 0;
    this.getTableData(); // 获取表格数据
    this.getChanceList(); // 获取商机列表
  },
  computed: {
    // 根据借款状态判断借款进度
    stepActive() {
      switch (this.loanApplyDetail.state) {
        case 1: // 1.已提交申请
        case 4: // 4.已撤回
          return 1;
        // 2.审批完成
        case 3: // 3.申请失败(已驳回)
        case 9: // 9.无需审批
          return 2;
        case 5: // 5.已付款
          return 3;
        case 6: // 6.已还款
          return 4;
        default:
          return 1;
      }
    },
    stepTwoText() {
      switch (this.loanApplyDetail.state) {
        case 1: // 1.已提交申请
          return "审批中";
        case 2: // 2.审批完成
          return "审批完成";
        case 3: // 3.申请失败(已驳回)
          return "审批驳回";
        case 9: // 9.无需审批
          return "无需审批";
        default:
          return "审批完成";
      }
    },
    // 步骤一的文本
    stepOneText() {
      switch (this.loanApplyDetail.state) {
        case 4: // 4. 已撤回
          return "已撤回";
        default:
          return "已提交申请";
      }
    },
    // 步骤一的状态
    stepOneStatus() {
      switch (this.loanApplyDetail.state) {
        case 4: // 4. 已撤回
          return "error";
        default:
          return "success";
      }
    },
    // 步骤二的图标
    stepTwoIcon() {
      switch (this.loanApplyDetail.state) {
        case 1: // 1.已提交申请
          return "el-icon-loading";
        default:
          return "";
      }
    },
    //步骤二的状态
    stepTwoStatus() {
      switch (this.loanApplyDetail.state) {
        case 1: // 1.已提交申请
          return "process";
        case 2: // 2.审批完成
          return "success";
        case 3: // 3.申请失败(已驳回)
          return "error";
        case 9: // 9.无需审批
          return "success";
        case 4: // 4. 已撤回
          return "wait";
        default:
          return "success";
      }
    },
    stepThreeText() {
      switch (this.loanApplyDetail.state) {
        case 5: // 5. 已付款
        case 6: // 6. 已还款
          return "已付款";
        default:
          return "未付款";
      }
    },
    stepFourText() {
      switch (this.loanApplyDetail.state) {
        case 6: // 6. 已还款
          return "已还款";
        default:
          return "未还款";
      }
    },
    // 步骤三的状态
    stepThreeStatus() {
      switch (this.loanApplyDetail.state) {
        case 5: // 5. 已付款
        case 6: // 6. 已还款
          return "success";
        default:
          return "";
      }
    },
    stepFourStatus() {
      switch (this.loanApplyDetail.state) {
        case 6: // 6. 已还款
          return "success";
        default:
          return "";
      }
    },
  },
  methods: {
    repaymentDialogClose(){
      this.$refs.repaymentForm.resetFields();
      this.repaymentForm = {}
      this.repaymentDialogVisible = false;
    },
    handleInput(value) {
      // 将输入值转换为数字
      const numericValue = parseFloat(value);
      // 如果输入值是数字且为正数，则更新
      if (!isNaN(numericValue) && numericValue >= 0) {
        this.repaymentForm.amount = numericValue;
      } else {
        // 如果输入值不是正数，则清空输入框
        this.repaymentForm.amount = null;
      }
    },
    // 根据借款状态区分tag type
    getTagType(state) {
      switch (state) {
        case 1: // 1.已提交申请
        case 5: // 5.已付款
        case 9: // 9.无需审批
          return "";
        case 6: // 6.已还款
          return "info";
        case 2: // 2.审批完成
          return "success";
        case 3: // 3.申请失败(已驳回)
        case 4: // 4.已撤回
          return "danger";
        case 7: // 7.部分还款
          return "warning";
        default:
          return "";
      }
    },
    // 获取所有商机列表
    getChanceList() {
      // getProjects().then((res) => {
      //   if (res.code == 200) {
      //     this.chanceList = res.data; // 商机列表
      //   }
      // });
      if (!window.sessionStorage.getItem("projects")) {
        this.getRequest("/dim/project").then((resp) => {
          if (resp) {
            this.chanceList = resp.result;
            this.saveDictCache("projects", resp.result);
          }
        });
      } else {
        this.chanceList = this.dictCache("projects");
      }
    },
    // 财务操作付款和还款状态判断
    financeOperate(state) {
      if (state == 2 || state == 9) {
        return "pay";
      } else if (state == 5 || state == 7) {
        return "back";
      } else {
        return "";
      }
    },
    // 申请借款
    applySubmit() {
      this.$refs.inputForm.validate((valid) => {
        if (valid) {
          loanSubmit(this.loanForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "借款申请提交成功",
                type: "success",
              });
              this.loanApplyVisible = false; // 关闭弹窗
              this.getTableData(); // 刷新表格数据
            }
          });
        }
      });
    },
    // 获取表格数据
    getTableData() {
      this.loading = true;
      const queryObj = {
        page: this.queryForm.page,
        limit: this.queryForm.limit,
        state: this.queryForm.state,
      };
      this.queryForm.loanManName
        ? (queryObj.loanManName = this.queryForm.loanManName)
        : "";
      this.queryForm.rqScope[0]
        ? (queryObj.rqScope =
            this.queryForm.rqScope[0] + "," + this.queryForm.rqScope[1])
        : "";
      // 借款类型（表头下拉）：不选则不传
      this.queryForm.loanType
        ? (queryObj.loanType = this.queryForm.loanType)
        : "";
      getLoanApplyList(queryObj).then((res) => {
        if (res.code == 200) {
          this.loanTotal = 0;
          this.waitPayTotal = 0;
          this.overPayTotal = 0;
          res.data.forEach((item) => {
            let overPay = Number((item.amount - item.waitReturn).toFixed(2));

            if (item.state === 5 || item.state === 6 || item.state === 7) {
              this.loanTotal = Number(
                (this.loanTotal + item.amount).toFixed(2)
              );
              this.waitPayTotal = Number(
                (this.waitPayTotal + item.waitReturn).toFixed(2)
              );
              this.overPayTotal = Number(
                (this.overPayTotal + overPay).toFixed(2)
              );
            }
          });
          this.total = res.count; // 数据总条数
          this.tableData = res.data; // 表格数据
          this.loading = false; // 关闭加载
        }
      });
    },
    // 当前页改变回调
    onCurrentChange(page) {
      this.queryForm.page = page; // 修改当前页码
      this.getTableData(); // 刷新表格数据
    },
    // 每页显示条数改变回调
    onSizeChange(size) {
      this.queryForm.page = 1;
      this.queryForm.limit = size; // 修改每页显示条数
      this.getTableData(); // 刷新表格数据
    },
    // 日期选择回调
    onDateChange(val) {
      // 日期选择器
      if (!val) this.queryForm.rqScope = [];
      this.queryForm.page = 1; // 修改当前页码
      this.getTableData(); // 刷新表格数据
    },
    onSelectChange(val) {
      this.queryForm.page = 1; // 修改当前页码
      this.getTableData();
    },
    // 搜索
    search() {
      this.queryForm.page = 1; // 修改当前页码
      this.getTableData(); // 刷新表格数据
    },
    // 查看详情
    lookDetail(row) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getApprovalStageList({
        applyCode: row.applyCode, // 申请单编号
      }).then((res) => {
        // 获取审批阶段
        if (res.code == 200) {
          this.approvalStageList = res.data; // 审批阶段列表
          this.loanApplyDetail = row; // 借款详情
          loading.close();
          this.loanDetailVisible = true; // 打开借款详情弹窗
        }
      });
    },
    // 重置表单
    closeApplyDialog() {
      this.$refs.inputForm.resetFields(); // 重置表单
    },
    // 关闭详情弹窗
    closeDetailDialog() {
      this.loanApplyDetail = {}; // 清空借款详情
      this.approvalStageList = []; // 清空审批阶段列表
    },
    // 撤销
    quash() {
      this.$confirm("是否撤销这条借款记录?", "提示", {
        type: "warning",
      })
        .then(() => {
          loanCancel({
            id: this.loanApplyDetail.id, // 借款单id
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "撤销成功",
                type: "success",
              });
              this.getTableData(); // 刷新表格数据
              this.loanDetailVisible = false; // 关闭借款详情弹窗
            }
          });
        })
        .catch((err) => {});
    },
    // 付款和还款确认
    payReturn(id, payReturn) {
      this.$confirm(`是否进行付款确认操作?`, "提示", {
        type: "warning",
      }).then(() => {
        payReturnSubmit({
          id: id, // 借款单id
          payReturn: payReturn, // 1: 付款 2: 还款
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "付款确认成功",
              type: "success",
            });
            this.getTableData(); // 刷新表格数据
            this.loanDetailVisible = false; // 关闭借款详情弹窗
          }
        });
      });
    },
    // 还款操作
    openRepayment(row) {
      this.repaymentForm.id = row.id;
      this.repaymentForm.waitReturn = row.waitReturn;
      this.repaymentDialogVisible = true;
    },
    async confirmRepayment() {

      try {
        const res = await payReturnSubmit({
          id: this.repaymentForm.id,
          payReturn: 2,
          returnAmount: this.repaymentForm.returnAmount,
        });

        if (res.code === 200) {
          this.$message.success(`成功还款￥${this.repaymentForm.returnAmount}`);
          this.getTableData();
          this.repaymentDialogVisible = false;
          // 保留原有关闭详情弹窗逻辑
        }
      } catch (error) {
        console.error("还款失败:", error);
      }

    },
  },
};
</script>

<style lang="scss" scoped>
.outer {
  .mr-30 {
    margin-right: 30px;
  }

  .table {
    ::v-deep .el-table__header-wrapper {
      position: sticky; /* 设置粘性定位 */
      top: 0; /* 距离顶部的距离 */
      z-index: 10; /* 确保层级高于其他内容 */
      background-color: #fff; /* 设置背景色避免透明 */
    }

    ::v-deep .el-table__cell {
      > :empty::before {
        content: "--";
        color: gray;
      }
    }

    &::before {
      display: none;
    }
  }

  .alert {
    margin-bottom: 20px;
  }
  .queryRow {
    overflow: hidden;
    margin-bottom: 20px;
    .queryName {
      width: 300px;
      margin-right: 10px;
    }

    .dataPicker {
      margin-right: 10px;
    }
  }

  .loanDetailVisible {
    .steps {
      margin-top: 20px;
      margin-bottom: 30px;
      margin-left: -20px;
      ::v-deep .el-step.is-center .el-step__description {
        padding: 0;
      }
    }

    .quash {
      margin-top: 5px;
    }
  }
}
</style>
